var _path, _path2, _path3, _g, _g2, _path4, _path5, _g3, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _g4, _path14, _g5, _path15, _g6, _path16, _path17, _path18, _path19, _path20, _path21, _g7, _path22, _g8, _ellipse, _g9, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgRewardsUnlockRate(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 100,
    height: 100,
    viewBox: "0 0 100 100",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M59.6351 9.82001L62.2705 8.28267C64.3349 7.14065 66.2237 6.92103 67.6732 7.66774L70.3086 9.16115L69.2544 9.20507C69.518 9.64431 69.6937 10.0836 69.8254 10.6106C68.1124 10.6985 66.4433 11.006 65.6966 12.1919C65.5209 12.0601 65.3452 11.9284 65.1695 11.8405L62.2266 15.2226L59.6351 13.7732V9.82001Z",
    fill: "url(#paint0_linear_1235:43294)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M59.1051 29.6304C61.4331 28.2687 63.5854 25.4576 64.5517 22.4708L66.3086 17.1121C66.9236 15.1355 66.8357 13.4664 66.0012 12.4561C65.9133 12.3683 65.8255 12.2804 65.7376 12.1926C66.4404 11.0506 68.1535 10.6992 69.8665 10.6113C70.3496 12.3244 70.1739 14.5645 69.4272 16.9803L68.0217 21.3288L68.5048 21.9876C68.5048 21.9876 65.2106 30.3331 65.0349 30.421C64.9031 30.5088 63.4097 30.8163 62.3994 30.992C61.3892 32.0462 60.2472 32.9247 59.1051 33.5835L50.8914 38.3273V41.2702L48.2999 39.8207V35.8676L59.1051 29.6304Z",
    fill: "url(#paint1_linear_1235:43294)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M61.6993 31.0793C64.0273 29.7177 66.1796 26.9066 67.1459 23.9197L68.9029 18.561C69.4739 16.5844 69.386 14.9153 68.5515 13.9051C67.7169 12.8948 66.3992 12.807 64.8619 13.6855L62.2264 15.2228V11.2697L64.8619 9.73232C67.5412 8.19498 70.0009 8.32676 71.4504 10.0837C72.8999 11.8407 73.0756 14.9593 71.9775 18.3853L70.2206 23.744C68.6832 28.4878 65.345 32.9241 61.6993 35.0325L50.8941 41.2697V37.3165L61.6993 31.0793Z",
    fill: "url(#paint2_linear_1235:43294)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.3,
    filter: "url(#filter0_f_1235:43294)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M44 83C35.1634 83 28 81.433 28 79.5C28 77.567 35.1634 76 44 76C52.8366 76 60 77.567 60 79.5C60 81.433 52.8366 83 44 83Z",
    fill: "url(#paint3_linear_1235:43294)"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.3,
    filter: "url(#filter1_f_1235:43294)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M69.4515 88.792C60.9351 91.6264 53.2975 91.7192 52.3923 88.9994C51.4871 86.2796 57.6571 81.777 66.1735 78.9426C74.6899 76.1083 82.3276 76.0154 83.2328 78.7352C84.138 81.4551 77.9679 85.9576 69.4515 88.792Z",
    fill: "url(#paint4_linear_1235:43294)"
  }))), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M26.5623 65.9559L30.5594 65.9998C30.8668 65.7802 31.1743 65.6045 31.4818 65.4288C38.0264 61.6513 48.656 61.6513 55.2446 65.4288C55.6399 65.6484 56.0352 65.912 56.3866 66.1755L60.1641 66.2194V72.3249C60.1641 74.7846 58.5389 77.2883 55.2446 79.177C48.6999 82.9545 38.0703 82.9545 31.4818 79.177C28.1875 77.2883 26.5623 74.7846 26.5623 72.3249V65.9559V65.9559Z",
    fill: "url(#paint5_linear_1235:43294)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M43.3851 75.6624C34.1184 75.6624 26.6062 71.3163 26.6062 65.9552C26.6062 60.5941 34.1184 56.248 43.3851 56.248C52.6519 56.248 60.1641 60.5941 60.1641 65.9552C60.1641 71.3163 52.6519 75.6624 43.3851 75.6624Z",
    fill: "url(#paint6_linear_1235:43294)"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_f_1235:43294)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M31.4845 72.8074C38.0292 76.5848 48.6588 76.5848 55.2474 72.8074C58.366 71.0065 59.9911 68.6785 60.1668 66.3066C60.3425 68.8982 58.7173 71.5336 55.2474 73.5541C48.7027 77.3315 38.0731 77.3315 31.4845 73.5541C28.0585 71.5775 26.3894 68.9421 26.5651 66.3066C26.7408 68.6785 28.3659 71.0065 31.4845 72.8074Z",
    fill: "url(#paint7_linear_1235:43294)"
  }))), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M34.0724 63.3193C34.292 63.1876 34.5116 63.0558 34.7312 62.8801C37.5287 61.2482 41.3649 60.5787 45.0147 60.8715C47.5677 61.0657 50.0248 61.7446 51.9928 62.88C52.3003 63.0557 52.5639 63.2314 52.8274 63.4071H53.8816V69.0732C53.3545 69.5564 52.7395 70.0396 51.9928 70.4788C51.2072 70.9321 50.3436 71.3074 49.4271 71.6083C44.7731 73.1731 38.7045 72.7967 34.7312 70.4789C32.3594 69.1173 31.1734 67.3164 31.1734 65.5155V63.2754L34.0724 63.3193ZM55.5508 63.4063H53.8817V69.0725C54.9798 67.9744 55.5508 66.7445 55.5508 65.5146V63.4063Z",
    fill: "url(#paint8_linear_1235:43294)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M43.3839 70.3037C36.6643 70.3037 31.2169 67.1572 31.2169 63.2759C31.2169 59.3945 36.6643 56.248 43.3839 56.248C50.1035 56.248 55.5508 59.3945 55.5508 63.2759C55.5508 67.1572 50.1035 70.3037 43.3839 70.3037Z",
    fill: "url(#paint9_linear_1235:43294)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M49.8807 57.5232C46.279 59.5876 40.4371 59.5876 36.8353 57.5232C33.2336 55.4587 33.2336 52.0766 36.8353 49.9682C40.4371 47.9038 46.279 47.9038 49.8807 49.9682C53.4825 52.0766 53.4825 55.4587 49.8807 57.5232Z",
    fill: "white"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M54.144 59.1051C52.2113 57.6556 52.5627 56.25 52.5627 56.25L51.1132 58.007C46.633 55.8547 40.0883 55.8547 35.652 58.007L34.1586 56.25C34.1586 56.25 34.5539 57.6556 32.5773 59.1051C30.6447 60.5545 31.2596 63.3657 31.2596 63.3657C31.2596 65.1666 32.4456 66.9235 34.8175 68.2851C39.5173 71.0084 47.204 71.0084 51.9039 68.2851C54.2757 66.9235 55.4617 65.1226 55.4617 63.3657C55.4617 63.3657 56.0766 60.5545 54.144 59.1051Z",
    fill: "url(#paint10_linear_1235:43294)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M49.8807 59.6755C46.279 61.7399 40.4371 61.7399 36.8353 59.6755C33.2336 57.6111 33.2336 54.2289 36.8353 52.1206C40.4371 50.0562 46.279 50.0562 49.8807 52.1206C53.4825 54.2289 53.4825 57.5671 49.8807 59.6755Z",
    fill: "url(#paint11_linear_1235:43294)"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M19.2277 19.9238C19.4912 33.3645 26.3873 34.9897 30.1208 40.041C33.5908 44.7408 33.1955 51.549 33.1076 52.4275C33.1076 52.4714 33.1076 52.5153 33.1076 52.5153C33.1076 54.0527 34.1179 55.5461 36.0944 56.6881C40.0915 59.0161 46.5922 59.0161 50.5893 56.6881C52.478 55.59 53.4444 54.1845 53.5761 52.7789H53.6201V52.5153C53.6201 52.4714 53.6201 52.4714 53.6201 52.4275C53.5322 51.549 53.1369 44.7408 56.6069 40.041C60.2965 34.9897 67.2365 33.3645 67.5 19.9238H19.2277V19.9238Z",
    fill: "url(#paint12_linear_1235:43294)"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M36.8406 34.5935C36.8406 34.5935 37.4116 36.2186 39.1686 40.7867C40.9255 45.3987 40.091 57.0386 40.091 57.0386L37.1042 57.2582C36.7528 57.0825 36.4014 56.9507 36.0939 56.7311C34.0734 55.5891 33.1071 54.0517 33.1071 52.5583C33.1071 52.5144 33.1071 52.4705 33.1071 52.4705C33.1949 51.592 33.5903 44.7838 30.1203 40.0839C26.4307 35.0327 19.4907 33.4075 19.2271 19.9668H21.8626L36.8406 34.5935Z",
    fill: "url(#paint13_linear_1235:43294)"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M43.3848 33.8477C30.0427 33.8477 19.2267 27.6138 19.2267 19.9239C19.2267 12.2339 30.0427 6 43.3848 6C56.727 6 67.543 12.2339 67.543 19.9239C67.543 27.6138 56.727 33.8477 43.3848 33.8477Z",
    fill: "url(#paint14_linear_1235:43294)"
  })), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter3_f_1235:43294)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M60.4262 29.8061C50.9825 35.2526 35.697 35.2526 26.2973 29.8061C21.861 27.2585 19.4891 23.9202 19.2695 20.582C19.0059 24.3595 21.3339 28.1809 26.2973 31.0359C35.7409 36.4825 51.0265 36.4825 60.4262 31.0359C65.3896 28.1809 67.7615 24.3156 67.454 20.582C67.2344 23.9202 64.8625 27.2145 60.4262 29.8061Z",
    fill: "url(#paint15_linear_1235:43294)"
  }))), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M43.3839 31.6077C32.2007 31.6077 23.135 26.3767 23.135 19.924C23.135 13.4712 32.2007 8.24023 43.3839 8.24023C54.5671 8.24023 63.6328 13.4712 63.6328 19.924C63.6328 26.3767 54.5671 31.6077 43.3839 31.6077Z",
    fill: "url(#paint16_linear_1235:43294)"
  })), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter4_f_1235:43294)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M29.0219 12.7205C36.9282 8.15239 49.754 8.15239 57.6603 12.7205C61.3938 14.8727 63.3704 17.6399 63.59 20.4511C63.8536 17.2886 61.877 14.0821 57.6603 11.6663C49.754 7.09821 36.9282 7.09821 29.0219 11.6663C24.8492 14.0821 22.8726 17.2886 23.0922 20.4511C23.3558 17.6399 25.3323 14.8727 29.0219 12.7205Z",
    fill: "url(#paint17_linear_1235:43294)"
  }))), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M33.4589 30.1142C39.6082 32.0908 47.1632 32.0908 53.3125 30.1142C53.0929 29.9824 52.8733 29.8507 52.6536 29.7189C47.5585 26.776 39.2569 26.776 34.1178 29.7189C33.8542 29.8507 33.6346 29.9824 33.4589 30.1142Z",
    fill: "url(#paint18_linear_1235:43294)"
  })), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter5_f_1235:43294)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M53.6211 52.4265C53.6211 52.3386 53.6211 52.119 53.5772 51.8555C53.4015 53.261 52.4351 54.5787 50.6343 55.6768C46.6372 58.0048 40.1365 58.0048 36.1394 55.6768C34.3385 54.6227 33.3722 53.305 33.1526 51.9433C33.1526 52.1629 33.1526 52.3386 33.1086 52.4265C33.1086 52.4704 33.1086 52.5143 33.1086 52.5143C33.1086 54.0517 34.1189 55.5451 36.0955 56.6871C40.0925 59.0151 46.5933 59.0151 50.5903 56.6871C52.4791 55.589 53.4454 54.1834 53.5772 52.7779H53.6211V52.5143C53.6211 52.5143 53.6211 52.4704 53.6211 52.4265Z",
    fill: "url(#paint19_linear_1235:43294)"
  }))), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M21.6415 50.1023C22.7396 50.805 24.3208 50.7172 25.9899 49.7509L36.7952 43.5137L39.3867 44.9632L38.64 46.237L36.7952 46.7201V47.4229L25.9899 53.6601C24.7161 54.4068 23.5302 54.8021 22.3882 54.89C20.8069 53.5283 20.9826 51.7714 21.6415 50.1023Z",
    fill: "url(#paint20_linear_1235:43294)"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.1325 38.2527C16.8031 38.8442 16.5026 39.4575 16.2362 40.0872C14.7867 43.5132 14.611 46.8075 15.7091 49.0476L17.4661 52.3858C17.9053 53.2204 18.5203 53.8793 19.223 54.3185L21.8145 55.768L22.122 54.9774H22.4295L22.2099 54.7577L22.3856 54.2746H21.8145C20.8921 53.0008 21.1118 51.5074 21.6828 50.1018C21.2435 49.7943 20.8482 49.399 20.5847 48.8719L18.8277 45.5337C18.5642 44.9627 18.4324 44.3039 18.4324 43.5572L19.267 44.0403L24.3182 36.7929L27.876 32.9715L28.0078 32.0491L25.4163 30.5996L22.7809 32.1369C20.6286 33.4107 18.5642 35.6069 17.1147 38.2424L17.1325 38.2527Z",
    fill: "url(#paint21_linear_1235:43294)"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M28.5814 55.1528L39.3867 48.9156V44.9624L28.5814 51.1996C26.2535 52.5613 24.1012 52.2099 23.1349 50.3212L21.3779 46.9829C20.763 45.7531 20.8508 43.9522 21.6854 41.9756C22.52 40.043 23.8377 38.4178 25.375 37.5393L28.0104 36.002V32.0488L25.375 33.5862C22.6956 35.1235 20.2359 38.1103 18.8303 41.5364C17.3809 44.9624 17.2052 48.3007 18.3033 50.4529L20.0602 53.7911C21.5536 56.734 24.9358 57.2611 28.5814 55.1528Z",
    fill: "url(#paint22_linear_1235:43294)"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M80.4152 55.9941V78.5323C80.4152 79.0322 80.1259 79.4905 79.506 79.8238L60.9495 90.6137C59.627 91.4053 57.2713 91.2803 55.7421 90.4054C54.8742 89.9055 54.4609 89.2389 54.4609 88.6557V66.1176L80.4152 55.9941Z",
    fill: "url(#paint23_linear_1235:43294)"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M60.9527 68.0766L79.5092 57.2866C80.8317 56.4951 80.6664 55.162 79.1372 54.2454C77.6081 53.3289 75.2523 53.2456 73.9298 54.0371L55.3733 64.8271C54.0508 65.6187 54.2161 66.9518 55.7453 67.8683C57.2745 68.7432 59.6302 68.8681 60.9527 68.0766Z",
    fill: "url(#paint24_linear_1235:43294)"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter6_f_1235:43294)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1235:43294",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 65,
    y: 67,
    width: 11,
    height: 15
  }, _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M65.5898 77.0438V75.5884C65.5898 72.4502 66.9093 69.092 69.9085 68.1683C71.0233 67.8249 72.1923 67.7413 73.2831 68.1983C75.3346 69.0578 75.7335 71.8083 74.9927 74.0431C74.2519 76.2779 70.5477 77.6814 70.5477 77.6814V78.9131C70.5477 79.4096 70.4386 79.8171 70.2443 80.1569C68.9335 82.4505 65.5898 79.6855 65.5898 77.0438Z",
    fill: "#C4C4C4"
  }))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1235:43294)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M62.5131 74.3636L73.7955 67.884L78.3742 75.9447L65.3553 83.8759L62.5131 74.3636Z",
    fill: "url(#paint25_linear_1235:43294)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 13.0107,
    height: 9.27039,
    transform: "matrix(0.867162 -0.498026 0.493906 0.869515 62.8555 66.7988)",
    fill: "#00E5CC"
  })))), /*#__PURE__*/React.createElement("mask", {
    id: "mask1_1235:43294",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 65,
    y: 67,
    width: 12,
    height: 15
  }, _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M66.0664 77.5831V75.8558C66.0664 72.7176 67.382 69.3339 70.3965 68.4611C71.4468 68.157 72.5418 68.0972 73.566 68.5263C75.5659 69.3642 75.9548 72.0454 75.2326 74.2239C74.5104 76.4025 70.8995 77.7707 70.8995 77.7707V78.9714C70.8995 79.4115 70.7548 79.8262 70.5027 80.2111C69.0551 82.4209 66.0664 80.2248 66.0664 77.5831Z",
    fill: "#C4C4C4",
    stroke: "white"
  }))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_1235:43294)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M71.2185 77.2672H62.3984V70.5315C62.3984 68.1426 64.3278 66.207 66.7092 66.207H71.2185C74.2614 66.207 76.731 68.6845 76.731 71.7371C76.731 74.7897 74.2614 77.2672 71.2185 77.2672Z",
    fill: "url(#paint26_linear_1235:43294)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.898 76.5959L67.5649 73.2443L65.7317 71.0658C65.7317 68.6768 64.5169 69.7251 66.8983 69.7251C66.8983 69.7251 66.3983 71.7361 69.7315 73.0767C73.0646 74.4173 74.3979 74.9201 75.3978 77.4337C75.3978 80.4864 75.9409 76.5959 72.898 76.5959Z",
    fill: "url(#paint27_linear_1235:43294)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.7305 67.8848C67.5477 68.8001 69.2948 69.9549 73.0566 70.7012C75.2264 71.1378 76.9876 71.9686 78.3965 72.9121C77.5371 70.0112 74.8319 67.8848 71.6477 67.8848H66.7305Z",
    fill: "url(#paint28_linear_1235:43294)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.7305 67.8848C67.5477 68.8001 69.2948 69.9549 73.0566 70.7012C75.2264 71.1378 76.9876 71.9686 78.3965 72.9121C77.5371 70.0112 74.8319 67.8848 71.6477 67.8848H66.7305Z",
    fill: "url(#paint29_linear_1235:43294)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.3984 67.5469C67.2156 68.4622 68.9627 69.617 72.7246 70.3633C74.8944 70.7999 76.6555 71.6307 78.0644 72.5742C77.205 69.6733 74.4998 67.5469 71.3156 67.5469H66.3984Z",
    fill: "url(#paint30_linear_1235:43294)"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter7_f_1235:43294)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M67.0664 67.5469C67.8836 68.4622 69.6307 69.617 73.3926 70.3633C75.5623 70.7999 77.3235 71.6307 78.7324 72.5742C77.873 69.6733 75.1678 67.5469 71.9836 67.5469H67.0664Z",
    fill: "url(#paint31_linear_1235:43294)"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter8_f_1235:43294)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M69.2305 68.7215C69.786 68.498 71.497 68.2188 71.897 68.2188C72.397 68.2188 74.8968 68.5539 75.3968 70.5649",
    stroke: "#00E5CC",
    strokeWidth: 0.3,
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M66.0664 73.2461V78.2927V79.7259C66.0664 81.3813 67.7925 82.4612 69.2591 81.7244L69.738 81.4822C72.1325 80.271 72.767 77.1204 70.2328 76.2625C68.417 75.6569 66.0664 74.8711 66.0664 73.2461Z",
    fill: "url(#paint32_linear_1235:43294)"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter9_f_1235:43294)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M69.0715 72.9246C67.0275 71.8944 66.7174 70.5375 66.901 69.8926C66.1084 70.4872 65.7344 71.7772 65.7344 72.8492V77.9498H72.4087C73.3931 77.9498 74.2942 77.6064 75.0033 77.0369C74.6529 74.5578 71.8581 74.3233 69.0715 72.9246Z",
    fill: "url(#paint33_linear_1235:43294)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M68.7317 73.2625C66.6877 72.2323 66.2109 70.8754 66.3945 70.2305C65.6019 70.8251 65.3945 72.1151 65.3945 73.1871V78.2877H72.0688C73.0533 78.2877 73.9543 77.9443 74.6635 77.3748C74.3131 74.8957 71.5182 74.6612 68.7317 73.2625Z",
    fill: "url(#paint34_linear_1235:43294)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.0649 75.4242C65.72 74.5636 64.5247 72.8851 64.7083 72.2402C63.9157 72.8349 63.3984 73.7897 63.3984 74.8617V79.9623H70.0728C71.0572 79.9623 70.8555 80.0156 71.5647 79.4461C71.5647 76.7648 68.8981 76.5973 67.0649 75.4242Z",
    fill: "url(#paint35_linear_1235:43294)"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter10_f_1235:43294)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M65.3945 73.916V78.9626V80.3959C65.3945 82.0512 67.1206 83.1312 68.5872 82.3944L69.0661 82.1521C71.4606 80.9409 72.0951 77.7904 69.561 76.9324C67.7451 76.3268 65.3945 75.541 65.3945 73.916Z",
    fill: "url(#paint36_linear_1235:43294)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M65.3945 74.252V79.2986V80.7318C65.3945 82.3871 66.4262 82.9956 67.8928 82.2588L69.0661 82.488C71.4606 81.2769 72.0951 78.1263 69.561 77.2684C67.7451 76.6628 65.3945 75.877 65.3945 74.252Z",
    fill: "url(#paint37_linear_1235:43294)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.7344 74.9219V78.8039L65.7344 81.106C65.7344 82.3793 66.4485 82.7908 67.7146 82.224C67.7146 82.224 67.9069 82.224 69.2209 81.106C70.5349 79.988 70.7341 78.1059 69.4008 77.4355C67.8332 76.9697 65.7344 76.1719 65.7344 74.9219Z",
    fill: "url(#paint38_linear_1235:43294)"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter11_f_1235:43294)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M68.2305 75.7598C68.3416 76.5418 73.0635 77.7707 69.7304 81.1222",
    stroke: "url(#paint39_linear_1235:43294)",
    strokeLinecap: "round"
  })))), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 76.1492,
    cy: 56.1458,
    rx: 1.82827,
    ry: 1.40315,
    transform: "rotate(-3.69234 76.1492 56.1458)",
    fill: "url(#paint40_linear_1235:43294)"
  })), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter12_i_1235:43294)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M59.7401 66.3717C60.608 66.3717 61.3519 65.6635 61.3519 64.7469V54.7485C61.3519 51.3324 61.3598 47.3087 64.2941 45.6006L68.2419 42.792C69.3578 42.1255 70.391 41.9588 71.0109 42.3338C71.6722 42.7087 72.0442 43.6669 72.0442 45V48.8189C72.0442 49.6937 72.7467 50.4436 73.656 50.4436C74.5239 50.4436 75.2678 49.7354 75.2678 48.8189V45C75.2678 42.4588 74.3172 40.5424 72.6641 39.5426C70.9696 38.5427 68.8619 38.7094 66.6715 40.0008L62.7236 42.8094C58.7974 45.1007 58.1696 50.1659 58.1696 54.7485V64.7469C58.1283 65.6635 58.8722 66.3717 59.7401 66.3717Z",
    fill: "#F4F5FB"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f_1235:43294",
    x: 20,
    y: 68,
    width: 48,
    height: 23,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4,
    result: "effect1_foregroundBlur_1235:43294"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_f_1235:43294",
    x: 44.3047,
    y: 68.7539,
    width: 47.0156,
    height: 30.2266,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4,
    result: "effect1_foregroundBlur_1235:43294"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_f_1235:43294",
    x: 25.5508,
    y: 65.3066,
    width: 35.6289,
    height: 12.0801,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.5,
    result: "effect1_foregroundBlur_1235:43294"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter3_f_1235:43294",
    x: 18.25,
    y: 19.582,
    width: 50.2305,
    height: 16.5391,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.5,
    result: "effect1_foregroundBlur_1235:43294"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter4_f_1235:43294",
    x: 22.0742,
    y: 7.24023,
    width: 42.5391,
    height: 14.2109,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.5,
    result: "effect1_foregroundBlur_1235:43294"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter5_f_1235:43294",
    x: 32.1094,
    y: 50.8555,
    width: 22.5117,
    height: 8.57812,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.5,
    result: "effect1_foregroundBlur_1235:43294"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter6_f_1235:43294",
    x: 64.5898,
    y: 66.8828,
    width: 11.75,
    height: 15.1289,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.5,
    result: "effect1_foregroundBlur_1235:43294"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter7_f_1235:43294",
    x: 66.0664,
    y: 66.5469,
    width: 13.668,
    height: 7.02734,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.5,
    result: "effect1_foregroundBlur_1235:43294"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter8_f_1235:43294",
    x: 68.082,
    y: 67.0684,
    width: 8.46484,
    height: 4.64648,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.5,
    result: "effect1_foregroundBlur_1235:43294"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter9_f_1235:43294",
    x: 64.7344,
    y: 68.8926,
    width: 11.2695,
    height: 10.0566,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.5,
    result: "effect1_foregroundBlur_1235:43294"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter10_f_1235:43294",
    x: 64.3945,
    y: 72.916,
    width: 7.79297,
    height: 10.7148,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.5,
    result: "effect1_foregroundBlur_1235:43294"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter11_f_1235:43294",
    x: 67.2305,
    y: 74.7598,
    width: 4.6875,
    height: 7.36328,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.25,
    result: "effect1_foregroundBlur_1235:43294"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter12_i_1235:43294",
    x: 58.168,
    y: 38.8965,
    width: 17.1016,
    height: 31.4746,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.3 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_1235:43294"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1235:43294",
    x1: 63.7176,
    y1: 8.84515,
    x2: 63.8386,
    y2: 13.8201,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#008A7B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.484541,
    stopColor: "#569D95"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00E5CC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1235:43294",
    x1: 56.6522,
    y1: 16.7995,
    x2: 57.5214,
    y2: 35.8604,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#008A7B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.484541,
    stopColor: "#569D95"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00E5CC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_1235:43294",
    x1: 57.5474,
    y1: 16.2619,
    x2: 58.5895,
    y2: 29.9089,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00E5CC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9358,
    stopColor: "#13C0AE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_1235:43294",
    x1: 48.8697,
    y1: 81.6496,
    x2: 48.154,
    y2: 78.1701,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2E18BA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.302693,
    stopColor: "#725BFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9665FB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_1235:43294",
    x1: 73.5123,
    y1: 85.3299,
    x2: 70.5489,
    y2: 81.1169,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2E18BA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.302693,
    stopColor: "#725BFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9665FB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_1235:43294",
    x1: 55.9243,
    y1: 80.5831,
    x2: 33.5139,
    y2: 54.3596,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#321DB0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.269097,
    stopColor: "#5742D9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.57118,
    stopColor: "#725BFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#825DCD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_1235:43294",
    x1: 50.1173,
    y1: 57.5672,
    x2: 48.068,
    y2: 77.6242,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.265323,
    stopColor: "#69D7CB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.529957,
    stopColor: "#13C0AE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.973958,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_1235:43294",
    x1: 43.3661,
    y1: 66.3066,
    x2: 43.3661,
    y2: 76.3872,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.625,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_1235:43294",
    x1: 52.475,
    y1: 71.6907,
    x2: 39.4946,
    y2: 53.4833,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#321DB0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.269097,
    stopColor: "#5742D9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.57118,
    stopColor: "#725BFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#825DCD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_1235:43294",
    x1: 52.4805,
    y1: 69.2705,
    x2: 36.2564,
    y2: 50.2808,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#321DB0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.269097,
    stopColor: "#5742D9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.57118,
    stopColor: "#725BFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#825DCD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_1235:43294",
    x1: 52.4775,
    y1: 69.2929,
    x2: 36.2298,
    y2: 50.2628,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#321DB0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.269097,
    stopColor: "#5742D9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.57118,
    stopColor: "#725BFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#825DCD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_1235:43294",
    x1: 45.5621,
    y1: 57.9349,
    x2: 35.3648,
    y2: 49.5559,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B28DFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.463542,
    stopColor: "#9665FB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#725BFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_1235:43294",
    x1: 61.4092,
    y1: 55.6034,
    x2: 17.0155,
    y2: 17.9813,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#321DB0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.269097,
    stopColor: "#5742D9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.57118,
    stopColor: "#725BFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#825DCD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear_1235:43294",
    x1: 32.2745,
    y1: 45.7436,
    x2: 14.0785,
    y2: 40.8679,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B28DFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.463542,
    stopColor: "#9665FB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#725BFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint14_linear_1235:43294",
    x1: 50.7375,
    y1: 28.4753,
    x2: 44.6935,
    y2: 17.3231,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2E18BA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.302693,
    stopColor: "#725BFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9665FB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint15_linear_1235:43294",
    x1: 43.3649,
    y1: 20.582,
    x2: 43.3649,
    y2: 35.1208,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.625,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint16_linear_1235:43294",
    x1: 58.523,
    y1: 29.8901,
    x2: 31.555,
    y2: -1.70846,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#321DB0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.269097,
    stopColor: "#5742D9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.57118,
    stopColor: "#725BFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#825DCD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint17_linear_1235:43294",
    x1: 43.3445,
    y1: 8.24023,
    x2: 43.3445,
    y2: 20.4511,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.625,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint18_linear_1235:43294",
    x1: 50.8075,
    y1: 31.2964,
    x2: 48.1482,
    y2: 22.5584,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#321DB0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.269097,
    stopColor: "#5742D9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.57118,
    stopColor: "#725BFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#825DCD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint19_linear_1235:43294",
    x1: 43.3649,
    y1: 51.8555,
    x2: 43.3649,
    y2: 58.4331,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.625,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint20_linear_1235:43294",
    x1: 28.132,
    y1: 45.8098,
    x2: 28.2756,
    y2: 52.8944,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#008A7B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9999,
    stopColor: "#569D95"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00E5CC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint21_linear_1235:43294",
    x1: 19.9748,
    y1: 35.6795,
    x2: 20.9562,
    y2: 51.2978,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#22F4DD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.354167,
    stopColor: "#008A7B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#569D95"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint22_linear_1235:43294",
    x1: 24.2466,
    y1: 37.7296,
    x2: 24.831,
    y2: 47.9619,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00E5CC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9358,
    stopColor: "#13C0AE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint23_linear_1235:43294",
    x1: 57.2418,
    y1: 76.1282,
    x2: 80.66,
    y2: 73.7066,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#098678"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.200244,
    stopColor: "#569D95"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00E5CC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint24_linear_1235:43294",
    x1: 72.4884,
    y1: 57.0158,
    x2: 72.2994,
    y2: 63.3706,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#87EBE0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9358,
    stopColor: "#29CFBD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint25_linear_1235:43294",
    x1: 68.6574,
    y1: 81.9717,
    x2: 66.0672,
    y2: 75.2629,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3C31D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9804,
    stopColor: "#2880FA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint26_linear_1235:43294",
    x1: 69.7314,
    y1: 69.7262,
    x2: 74.2325,
    y2: 73.7465,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C2EAFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EEFFFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint27_linear_1235:43294",
    x1: 70.0179,
    y1: 74.1365,
    x2: 72.8261,
    y2: 71.3441,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0885417,
    stopColor: "#0080EE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.234375,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.364583,
    stopColor: "#0080EE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#01C5F6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#01C5F6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint28_linear_1235:43294",
    x1: 68.897,
    y1: 69.2254,
    x2: 74.8944,
    y2: 68.1176,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.161458,
    stopColor: "#BBE0FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.255208,
    stopColor: "#0080EE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.729167,
    stopColor: "#01C5F6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint29_linear_1235:43294",
    x1: 68.897,
    y1: 69.2254,
    x2: 74.8944,
    y2: 68.1176,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.161458,
    stopColor: "#BBE0FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.255208,
    stopColor: "#0080EE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.729167,
    stopColor: "#01C5F6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint30_linear_1235:43294",
    x1: 68.7316,
    y1: 68.2172,
    x2: 75.074,
    y2: 71.3823,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.166667,
    stopColor: "#00E5CC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.789253,
    stopColor: "#10DCC6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint31_linear_1235:43294",
    x1: 75.1709,
    y1: 68.7181,
    x2: 72.2292,
    y2: 69.5451,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E3FFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9358,
    stopColor: "#C1FFFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint32_linear_1235:43294",
    x1: 66.3997,
    y1: 75.4246,
    x2: 71.1997,
    y2: 78.027,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.161458,
    stopColor: "#FDFEFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9804,
    stopColor: "#E2F6FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint33_linear_1235:43294",
    x1: 66.7343,
    y1: 71.2332,
    x2: 73.7327,
    y2: 76.7648,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.213542,
    stopColor: "#FCA8FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.869792,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFF5FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint34_linear_1235:43294",
    x1: 67.3944,
    y1: 71.9063,
    x2: 71.5579,
    y2: 78.1086,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFE4FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFF5FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint35_linear_1235:43294",
    x1: 65.3983,
    y1: 73.5809,
    x2: 69.5618,
    y2: 79.7832,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F7A8FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F093FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint36_linear_1235:43294",
    x1: 65.8945,
    y1: 75.7594,
    x2: 71.1748,
    y2: 78.0052,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.120578,
    stopColor: "#FDFEFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.451663,
    stopColor: "#00B7FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9804,
    stopColor: "#E2F6FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint37_linear_1235:43294",
    x1: 68.561,
    y1: 82.6309,
    x2: 65.9139,
    y2: 76.3962,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#06D0FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9804,
    stopColor: "#E2F6FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint38_linear_1235:43294",
    x1: 68.4681,
    y1: 81.3672,
    x2: 66.5948,
    y2: 76.4154,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C2EAFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9804,
    stopColor: "#E2F6FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint39_linear_1235:43294",
    x1: 70.397,
    y1: 77.6031,
    x2: 68.7149,
    y2: 81.4506,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.438179,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.96858,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint40_linear_1235:43294",
    x1: 76.8612,
    y1: 55.3964,
    x2: 76.8149,
    y2: 56.5761,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2FB3A4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9358,
    stopColor: "#13C0AE"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRewardsUnlockRate);
export default __webpack_public_path__ + "static/media/rewards-unlock-rate.e2ce1be7.svg";
export { ForwardRef as ReactComponent };